import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  
    .my-css{
        outline: none;
        box-shadow: none;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;    
    }

    .dropdown-menu .show {
        border: ${props => props.theme.border.very_small_gray5};
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: ${props => props.theme.border_radius.medium};
        font-weight: ${props => props.theme.font_weight.medium};
        font-size: ${props => props.theme.font_size.small};
        line-height: ${props => props.theme.lines_height.medium};
        color: ${props => props.theme.colors.gray};
    }

    .dropdown-menu{
        background-color: ${props => props.theme.backgrounds.white};
    }

    .dropdown-item{
        color: ${props => props.theme.colors.black};
    }

    .dropdown-item:hover{
        background-color: ${props => props.theme.backgrounds.gray7};
    }
`;

